module.exports = __webpack_public_path__ + "img/add-to-order.0e80083d.svg";